<a class="action" [routerLink]="actionRouterLink" [ngClass]="buttonClass"><ng-content></ng-content></a>
